/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ActivityDetail } from '../models/ActivityDetail';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ActivitiesService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get activity
     * Get activity
     * @param activityId Activity ID
     * @returns ActivityDetail OK
     * @throws ApiError
     */
    public activity(
        activityId: string,
    ): Observable<ActivityDetail> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/activities/{activity_id}',
            path: {
                'activity_id': activityId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
